module.exports = __webpack_public_path__ + "static/media/10D.2640d172.jpg";